import { flow } from 'lodash';
import { groupBy, values, map } from 'lodash/fp';
import uniq from 'lodash/uniq';
import { LessonPreviewWeekData } from '../types';

export const flattenLessonPlanData = (data: any[] = []) => {
  return flow(
    groupBy('week'),
    values,
    map(x => ({
      ...(x[0] || {}),
      keys: uniq(
        x.reduce((acc: string[], y: any) => {
          return [...acc, ...(y.keys ? [y.keys] : [])];
        }, [])
      ),
      ...groupBy('day', x)
    }))
  )(data) as LessonPreviewWeekData[];
};

export const getLessonPlanDataByWeek = (
  data: LessonPreviewWeekData[] = [],
  week: number
): LessonPreviewWeekData | undefined => {
  return data.find((x: any) => x.week === week);
};
